export default {
  model () {
    return {
      name: '',
      division: '',
      description: '',
      onlyMainBranches: false,
      dealerTypes: [],
      status: 'unpublished',
      template: {
        scores: [],
        sections: []
      }
    }
  },
  rules: {
    name: {required: true, message: 'Indique el nombre del layout'},
    division: {required: true, message: 'Seleccione el área'},
    dealerTypes: [
      {required: true, message: 'Indique al menos un tipo de sucursal', trigger: 'change'}
    ]
  }
}



// WEBPACK FOOTER //
// ./src/modules/layouts/layout.model.js